import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import i18n from 'scripts/i18n/i18n';
import PhoneCall from 'models/phone_call';

const IncomingCallNotificationContent = ({
  customerDisplayName,
  incomingCallType,
  routingGroupName,
  transferringAgentName,
}) => {
  return (
    <div className="conversationNotification-topic">
      <i className="conversationNotification-icon fa fa-phone" />
      <div className="conversationNotification-topic-heading incomingCall-topic-heading">
        {i18n.t(INCOMING_CALL_TYPE_TEXT[incomingCallType])}
      </div>
      <div className="conversationNotification-divider" />
      {renderMessage(customerDisplayName, incomingCallType, routingGroupName, transferringAgentName)}
    </div>
  );
};

const renderMessage = (customerDisplayName, incomingCallType, routingGroupName, transferringAgentName) => {
  if (incomingCallType !== PhoneCall.IncomingCallType.WARM_TRANSFER) {
    return (
      <div className="conversationNotification-topic-body incomingCall-topic-body">
        <span>
          <Trans
            components={{ name: <span className="incomingCall-topic-body-customerName fs-mask" /> }}
            i18nKey="From <name>{{customerDisplayName}}</name>"
            values={{ customerDisplayName }}
          />
          {routingGroupName ? i18n.t(' to {{routingGroupName}}', { routingGroupName }) : null}
        </span>
      </div>
    );
  }
  return (
    <div className="conversationNotification-topic-body">
      <Trans
        components={{
          body: <span className="incomingWarmTransfer-notification-body" />,
          mask: <span className="fs-mask" />,
        }}
        i18nKey={
          routingGroupName
            ? '{{transferringAgentName}}<body> is transferring </body><mask>{{customerDisplayName}}</mask><body> to you</body> from {{routingGroupName}}'
            : '{{transferringAgentName}}<body> is transferring </body><mask>{{customerDisplayName}}</mask><body> to you</body>'
        }
        values={{ customerDisplayName, routingGroupName, transferringAgentName }}
      />
    </div>
  );
};

export const INCOMING_CALL_TYPE_TEXT = Object.freeze({
  [PhoneCall.IncomingCallType.BLIND_TRANSFER]: 'Cold Transfer',
  [PhoneCall.IncomingCallType.INCOMING]: 'Incoming Call',
  [PhoneCall.IncomingCallType.WARM_TRANSFER]: 'Warm Transfer',
});

IncomingCallNotificationContent.propTypes = {
  customerDisplayName: PropTypes.string.isRequired,
  incomingCallType: PropTypes.string.isRequired,
  routingGroupName: PropTypes.string,
  transferringAgentName: PropTypes.string,
};

export default IncomingCallNotificationContent;
